import React from 'react';
import { Typography } from 'antd';
import { Echo } from '../components/Echo';
import { LATER_SECTIONS } from '../components/Shell';

export const ComingLaterScreen: React.FC<{ section: string }> = ({ section }) => {
  const label = LATER_SECTIONS.find((s) => s.key === section)?.label ?? 'This section';
  return (
    <div style={{ textAlign: 'center', padding: '64px 0' }}>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Echo mood="sleeping" size={120} />
      </div>
      <Typography.Title level={3} style={{ marginTop: 16 }}>
        {label}: coming later
      </Typography.Title>
      <Typography.Paragraph type="secondary">
        Public decks and cards can be managed for now.
      </Typography.Paragraph>
    </div>
  );
};
